import { render, staticRenderFns } from "./ListaItensVenda.vue?vue&type=template&id=4fc75bf1&scoped=true&"
import script from "./ListaItensVenda.vue?vue&type=script&lang=js&"
export * from "./ListaItensVenda.vue?vue&type=script&lang=js&"
import style0 from "./ListaItensVenda.vue?vue&type=style&index=0&id=4fc75bf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc75bf1",
  null
  
)

export default component.exports